import {RepositoryPickerPossibleTransferRepositoriesServerQuery} from '@github-ui/server-persisted-queries'
import type {RepositoryPickerPossibleTransferRepositoriesServerQueryQuery} from '@github-ui/server-persisted-queries/types/RepositoryPickerPossibleTransferRepositoriesServerQuery'
import {reactFetchJSON} from '@github-ui/verified-fetch'

type IssueNode = Extract<
  NonNullable<RepositoryPickerPossibleTransferRepositoriesServerQueryQuery['node']>,
  {readonly possibleTransferRepositoriesForViewer: unknown}
>
type RepositoryConnection = NonNullable<IssueNode['possibleTransferRepositoriesForViewer']>
export type PossibleTransferRepository = NonNullable<NonNullable<RepositoryConnection['edges']>[number]>['node']

export type IssueTransferContext = {
  owner: string
  repository: string
  issueNumber: number
}

export function possibleTransferRepositoriesQueryKey(
  {owner, repository, issueNumber}: IssueTransferContext,
  searchQuery: string,
) {
  return ['item-picker', 'possible-transfer-repositories', {owner, repository, issueNumber, searchQuery}] as const
}

export async function fetchPossibleTransferRepositories(
  {owner, repository, issueNumber}: IssueTransferContext,
  searchQuery: string,
  signal?: AbortSignal,
): Promise<PossibleTransferRepository[]> {
  const query = new URLSearchParams({
    queryId: RepositoryPickerPossibleTransferRepositoriesServerQuery,
    searchQuery,
  })
  const response = await reactFetchJSON(
    `/${owner}/${repository}/issues/${issueNumber}/possible_transfer_repositories.json?${query.toString()}`,
    {signal},
  )

  if (!response.ok) throw new Error(`Possible transfer repositories fetch failed (${response.status})`)

  const json = (await response.json()) as {
    data?: RepositoryPickerPossibleTransferRepositoriesServerQueryQuery
    errors?: unknown[]
  }
  if (!json.data) throw new Error('Possible transfer repositories query returned no data')

  const node = json.data.node
  if (!node || !('possibleTransferRepositoriesForViewer' in node)) return []

  return (node.possibleTransferRepositoriesForViewer?.edges || []).flatMap(edge => (edge?.node ? [edge.node] : []))
}
